"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const CommonStyle = (0, styled_components_1.createGlobalStyle) `
    * {
        box-sizing: border-box;
    }
    body {
        background-color: #ece9e9;
        // #131313
    }
    #app {
        display: flex;
        flex-flow: column wrap;
    }
`;
const Header = styled_components_1.default.header `
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin: 0;
    padding: 12px;
`;
const Logo = styled_components_1.default.h1 `
    color: #F58840;
`;
const Main = styled_components_1.default.main `
    display: flex;
    justify-content: center;
    flex: 1 90vh;
    margin: 3px 0;
`;
const Footer = styled_components_1.default.footer `
    display: flex;
    justify-content: center;
`;
const Copy = styled_components_1.default.small `
    color: #535252;
`;
const Layout = (props) => {
    const { children } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CommonStyle, null),
        react_1.default.createElement(Header, { role: "header" },
            react_1.default.createElement(Logo, null, "\uD1A0\uB9C8\uD1A0\uD1A1")),
        react_1.default.createElement(Main, { role: "main" }, children),
        react_1.default.createElement(Footer, { role: "footer" },
            react_1.default.createElement(Copy, null, "Copyright 2021. \uB958\uC724\uC885 All Right Reserve."))));
};
exports.default = Layout;
